import { Box, Grid, Typography } from "@mui/material";
import Footer from "./Footer";

const Contact = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "30vh",
          backgroundColor: "#f9f9f9",
          px: 10,
        }}
      >
        <Grid container spacing={12}>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "500px",
              }}
            >
              <Typography variant="h5" gutterBottom>
                Address
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                Head Office (Bangkok) 1041/7 Soi Silom 21 Silom Road, Silom
                Bangrak, Bangkok 10500 Thailand (Mon-Fri : 8.30-17.30)
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h5" gutterBottom>
                Contact
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Call</Typography>
                <Typography variant="body1">02-123-4567</Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1">Email</Typography>
                <Typography variant="body1">
                  eposservicegroup@eposservice.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Footer />
      <Box
        sx={{
          height: "20px",
          backgroundImage: "linear-gradient(to right, #4cb8ba, #7bd867)",
        }}
      ></Box>
    </>
  );
};

export default Contact;
